import React, {useContext} from "react"
import {Grid, Slider, Stack, Typography} from "@mui/material"
import {getMerkmal} from "../../misc/widget-functions"
import {DataContext} from "../../../src/context/DataContextProvider"
import _ from "lodash"

export const widgetHorizontalSliderPrototype = [
    {
        key: "rangeStart",
        type: "INTEGER",
        label: "Bereich Anfang",
        size: 3,
    },
    {
        key: "rangeEnd",
        type: "INTEGER",
        label: "Bereich Ende",
        size: 3,
    },
    {
        key: "rangeStartPointer",
        type: "STRING",
        label: "Bereich Anfang Pointer",
        size: 3,
    },
    {
        key: "rangeEndPointer",
        type: "STRING",
        label: "Bereich Ende Pointer",
        size: 3,
    },
    {
        key: "rangeStep",
        type: "INTEGER",
        label: "Schrittweite",
        size: 3,
    },
]

const safeparsePointerDataToNumber = (data) => {
    const parsed = Number.parseInt(data)
    return _.isNaN(parsed) ? 0 : parsed
}

const createRangeArray = (rangeStart = 0, rangeEnd = 10, rangeStep = 1) => {
    const length = Math.floor((+rangeEnd - +rangeStart) / +rangeStep) + 1

    return Array.from({length}, (_, index) => +rangeStart + index * +rangeStep)
}

const HorizontalSliderWidget = ({
                                    widget,
                                    onValueChange,
                                    disabled,
                                }) => {
    const {rangeStart, rangeEnd, rangeStep, rangeStartPointer, rangeEndPointer} = widget
    const {getDataFromPointer} = useContext(DataContext)

    const onChange = (event, newValue) => {
        onValueChange(newValue)
    }

    const startRangeFromPointer = getDataFromPointer(rangeStartPointer)
    const endRangeFromPointer = getDataFromPointer(rangeEndPointer)

    const start = rangeStartPointer
        ? safeparsePointerDataToNumber(startRangeFromPointer)
        : safeparsePointerDataToNumber(rangeStart)

    const end = rangeEndPointer
        ? safeparsePointerDataToNumber(endRangeFromPointer)
        : safeparsePointerDataToNumber(rangeEnd)

    const defaultValue = getMerkmal(widget) ?? 0

    const marks = createRangeArray(
        rangeStart,
        rangeEnd,
        rangeStep,
    ).map((entry) => ({
        value: entry,
        label: entry,
    }))

    return (
        <Stack>
            {widget.text && (
                <Typography className={disabled ? "disabled" : ""}>
                    {widget.text}
                </Typography>
            )}
            <Grid sx={{marginLeft: "12px", marginRight: "22px"}}>
                <Slider
                    valueLabelDisplay="auto"
                    defaultValue={defaultValue}
                    onChange={onChange}
                    marks={marks}
                    step={Number.parseInt(rangeStep)}
                    min={start}
                    max={end}
                    sx={{height: "6px"}}
                />
            </Grid>
        </Stack>
    )
}

export default HorizontalSliderWidget
